/*
 * Copyright (c) 2024. Haodong JU
 */

import { getCurrentDeviceId } from '@/model/dataLayer/service/RestaurantInfoService'
import hillo from 'hillo'

export const storageNewApiHost = location.protocol + '//cloud-v2.aaden.io/inventory/'
// export const storageNewApiHost = location.protocol + '//192.168.110.12/inventory/'

export async function getCurrentShopInfo () {
  return {
    shop: '/shops/' + await getCurrentDeviceId(),
    shopId: await getCurrentDeviceId()
  }
}

function postProcess (halJson) {
  return {
    ...halJson,
    id: halJson._links?.self?.href
  }
}

export async function storagePost (url, data) {
  try {
    return postProcess(await hillo.jsonPost(
      storageNewApiHost + url,
      {
        ...await getCurrentShopInfo(),
        ...data
      }))
  } catch (e) {
    return {
      error: true,
      message: e.message
    }
  }
}

export async function storageGet (url, data) {
  return await hillo.get(
    storageNewApiHost + url,
    {
      ...await getCurrentShopInfo(),
      ...data
    })
}

export async function checkStorageStatus () {
  return (await hillo.get(storageNewApiHost + 'shop/info/' + await getCurrentDeviceId()))
}

export async function openStorage (info) {
  info.id = await getCurrentDeviceId()
  return (await hillo.jsonPost(storageNewApiHost + 'shop/save', {
    ...info
  }))
}
